import { IConsentPreference } from './gdpr';
import { IEndUser } from './user';

export type IAction = Record<string, unknown> & {
  id: string;
  collection: string;
  consentPreferences: IConsentPreference[];
  consentsRevoked?: boolean;
  consentsRevokedDate?: string | Date;
  endUser: IEndUser;
  email?: string;
  password?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type IActionEmailData = {
  id?: string;
  from?: string;
  to?: string;
  cc?: string;
  bcc?: string;
  subject: string;
  html: string;
};
